{
  "stepper": {
    "title": "Workflow Progress",
    "discardReason": "Reason: {{comment}}",
    "readyToScheduleVisit": "Ready to schedule a visit",
    "dateLabel": "Date:",
    "addressLabel": "Address:",
    "commentLabel": "Comment:"
  },
  "commentForm": {
    "defaultTitle": "Add Comment",
    "commentLabel": "Comment",
    "commentPlaceholder": "Enter your comment here...",
    "commentRequired": "Comment is required",
    "submit": "Submit"
  },
  "visitSchedule": {
    "title": "Schedule Visit",
    "dateLabel": "Visit Date and Time",
    "addressLabel": "Visit Address",
    "addressPlaceholder": "Enter the full address for the visit",
    "dateRequired": "Visit date is required",
    "dateInFuture": "Visit date must be in the future",
    "addressRequired": "Visit address is required",
    "submit": "Schedule"
  }
}
